export default {
  list: {
    isLoading: false,
    error: '',
    data: {
      items: [],
      count: 0,
    },
  },
};
